import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M3.5 17.358A6.36 6.36 0 0 1 9.858 11h.284a6.36 6.36 0 0 1 6.358 6.358.64.64 0 0 1-.642.642H4.142a.64.64 0 0 1-.642-.642" />
    <rect width={6} height={6} x={7} y={4} rx={3} />
  </svg>
);
export default SvgUser;
